import { theme, ThemeConfig } from 'antd';

// antd modals and inputs inside the dashboard, matched to the 1browser design tokens (global.css --ob-*)
export const OB_ANTD_THEME: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: '#2395f2',
    colorError: '#ff5d62',
    colorBgElevated: '#2f3a4b',
    colorBgContainer: '#252c37',
    colorBorder: '#596475',
    colorText: '#d3dbdf',
    colorTextHeading: '#f3f4f4',
    colorTextPlaceholder: '#98a1ae',
    fontFamily: '"Roboto Flex", Arial, sans-serif',
    borderRadius: 10,
    borderRadiusLG: 16,
    controlHeight: 44,
  },
  components: {
    Button: {
      borderRadius: 22,
      primaryShadow: 'none',
    },
  },
};
